export default {"src":"/_next/static/media/average-icon.2a3987d5.svg","height":49,"width":50};